<template>
  <section id="shipments" class="bg-gray">
    <div class="container">

      <div class="cart-row">
        <p v-html="getTranslatedName('choose_shipping')"></p>
      </div>
      <div class="cart-row" :key="shipment.internal_name" v-for="shipment in shipments" :class="{'active': shipment.internal_name === selectedShipment.internal_name}">

        <div class='shipment-select' v-if="isValid(shipment)">
          <label class="form-item">
            <input type='radio' :value="shipment.internal_name" name='shipment' v-on:click="setShipment(shipment.internal_name)" :checked="shipment.internal_name === selectedShipment.internal_name ? 'checked' : ''">
            <span class="radiobtn"></span> <span v-html="getTranslatedName(shipment.internal_name)"></span>
          </label>
        </div>
        <div class='shipment-cost' v-html="getShipmentCost(shipment)" v-if="isValid(shipment)"></div>

      </div>
    </div>
  </section>
</template>

<script>
  import store from "./../../store/index"

  export default {
    name: "Shipments",
    computed: {
      itemsTotal() {
        return store.getters.itemsTotal;
      },
      shipments() {
        return store.getters.shipments;
      },
      selectedShipment() {
        if ('internal_name' in store.getters.shipment) {
          return store.getters.shipment;
        } else {
          return {internal_name: 'none'}
        }
      }
    },

    methods: {
      getTranslatedName(name) {
        if(typeof  window.translations['CART_' + name] !== 'undefined')
          return window.translations['CART_' + name];
        return name;
      },
      getShipmentCost(shipment) {
        if(shipment.freeFrom > 0 && (this.itemsTotal * 100) > (shipment.freeFrom)) {
          return this.getPrice(0);
        }
        return this.getPrice(shipment.cost / 100);

      },
      isValid(shipment) {

        let hasBike = this.hasBike();

        // jeśli jest rower w koszyku to umożliwiamy wysyłkę do dealera
        if(shipment.internal_name === 'dealer') {
          if( ! hasBike && store.getters.shipment.internal_name === "dealer") {
            store.dispatch('setShipment', "");
          }
          return hasBike;
        }

        if(shipment.internal_name === 'dhl') {
          if(hasBike) return false;
        }

        return true;
      },
      getPrice(price) {
        return this.$options.filters.full_price(price)
      },
      setShipment(internal_name) {
        store.dispatch('setShipment', internal_name);
      },

      hasBike() {
        let bikeType = 3;
        let cartItems = store.getters.items;
        let hasBike = false;
        // musimy wyszukać w koszyku rower którego ilośc jest większa niż 0
        _.forEach(cartItems, function (item) {
          if(item.type === bikeType && item.qty > 0) {
            hasBike = true;
          }
        });
        return hasBike;
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Cart/Shipments.vue